<template>
  <div class="news-all">
    <TableHeaderBasic
      @searchKeyWord="$store.dispatch('fetchNewlyAddedNewsAll')"
      @searchDate="$store.dispatch('fetchNewlyAddedNewsAll')"
    ></TableHeaderBasic>
    <TablePagination
      @updatePage="$store.dispatch('fetchNewlyAddedNewsAll')"
    ></TablePagination>
    <TableList
      :isSelectable="$store.getters.loggedInInfo.is_admin"
      :fields="fields"
      :items="$store.getters.newlyAddedNewsAllList"
      @click="openModal($event)"
      @toDetail="toDetail"
    >
    </TableList>

    <!-- modal -->
    <b-modal ref="double-check-delete">
      <p class="text-center">是否刪除？</p>
      <template v-slot:modal-footer>
        <div class="text-center">
          <b-button @click="submit" class="mr-3" type="button" variant="primary"
            >確定</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import TableHeaderBasic from "@/components/TableHeaderBasic.vue";
import TablePagination from "@/components/TablePagination.vue";
export default {
  components: {
    TableList,
    TableHeaderBasic,
    TablePagination
  },
  computed: {
    fields() {
      return [
        { key: "created_at", label: "創建日期" },
        { key: "stock.stock_symbol", label: "股票代號" },
        { key: "stock.company_name", label: "公司名稱" },
        { key: "title", label: "標題" },
        { key: "user", label: "轉貼者" }
      ];
    }
  },
  data() {
    return {
      deleteData: {
        news_ids: []
      }
    };
  },
  methods: {
    openModal(selectedList) {
      this.$refs["double-check-delete"].show();
      this.setDeleteData(selectedList);
    },
    setDeleteData(selectedList) {
      this.deleteData.news_ids = selectedList.map(item => item.id);
    },
    submit() {
      this.$store.dispatch("deleteOneNews", this.deleteData).then(() => {
        this.$refs["double-check-delete"].hide();
        this.$store.dispatch("fetchNewlyAddedNewsAll");
      });
    },
    toDetail(oneNews) {
      this.$router.push({
        name: "newlyAddedOneNewsRead",
        params: { oneNewsId: oneNews.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
